import { styled } from '@mui/system';
import { ReactComponent as DownloadIcon } from "../images/download-icon.svg";

export const StyledDownloadIcon = styled(DownloadIcon)`
  padding: 1em;
  height: 6.5rem;
`;